import { Spin } from 'antd';

import { useMaterialPage } from './hooks';

import MaterialsList from '~organisms/MaterialsList';
import { ProductReplacementModal } from '~organisms/ProductReplacementModal';
import MaterialsTemplate from '~templates/Materials';

const MaterialPage = () => {
  const {
    isFetchingMaterials,
    materialsList,
    selectedMaterial,
    selectMaterialId,
    closeModal,
    candidateMaterial,
    selectCandidateMaterial,
    removedProducts,
  } = useMaterialPage();

  return isFetchingMaterials ? (
    <Spin style={{ fontSize: 24 }} />
  ) : (
    <>
      <MaterialsTemplate
        materialsSlot={
          <MaterialsList
            data={{ materials: materialsList }}
            selectedMaterialId={selectedMaterial?.id}
            onSelectMaterial={selectMaterialId}
          />
        }
      />

      <ProductReplacementModal
        newProductName={candidateMaterial?.name}
        typeOfProduct="material"
        productsToReplace={removedProducts}
        onCancel={closeModal}
        onConfirm={() =>
          candidateMaterial?.id
            ? selectCandidateMaterial(candidateMaterial.id)
            : undefined
        }
      />
    </>
  );
};

export default MaterialPage;
